<template>
  <div class="saque_card">
    <div class="top_bar">
      <div class="left_section">
        <span class="title"> {{ props.text }}</span>
        <div class="fund_icon" @click="handleFundClick">
           <img src="@/assets/themeFour/history.png" alt="" style="width: 15px;"/>
        </div>
      </div>
      <van-icon name="cross" size="22" class="close_icon" @click="handleBackClick" v-if="!hideBacKIcon"/>
    </div>

    <div class="content_text">
      {{ props.subText }}  
    </div>

    <div class="support_link" @click="goToSupport">
      <van-icon name="service-o" size="16" />
      <span>{{ $t('common.support') }}</span>
    </div>

  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { navToBack } from '@/view/components/supportFunction'

const router = useRouter()
const userStore = useUserStore()

const emits = defineEmits(['closePopup', 'goToFund'])

const props = defineProps({
  isPopupCloseBackIcon: {
    type: Boolean,
    default: true
  },
  text: {
        type: String,
        default: () => ''
    },
   subText: {
        type: String,
        default: () => ''
    }, 
   hideBacKIcon:{
        type: Boolean,
        default: () => false,
        required: false
    } 
})

const handleBackClick = () => {
  navToBack(router, props.isPopupCloseBackIcon, emits)
  userStore.setRechargeBonusType(0)
}

const handleFundClick = () => {
  emits('goToFund')
}

const goToSupport = () => {
  router.push('/sd-message')
}
</script>

<style scoped>
.saque_card {
  background: #024A49;
  color: #fff;
  padding: 16px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-sizing: border-box; 
  z-index: 1000;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.top_bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left_section {
  display: flex;
  align-items: center;
  gap: 10px;
}

.title {
  font-size: 22px;
  font-weight: 700;
}

.fund_icon {
  width: 32px;
  height: 32px;
  background: #1aa39a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.close_icon {
  cursor: pointer;
  font-weight: 700;
}

.content_text {
  margin-top: 14px;
  font-size: 14px;
  line-height: 1.6;
  font-weight: bold;
}

.support_link {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ffc107;
  font-weight: 700;
  cursor: pointer;
  font-size: 14px;
}

@media (max-width: 360px) {
  .title {
    font-size: 18px;
  }

  .content_text {
    font-size: 13px;
  }
}

@media (min-width: 1440px) {
   .title {
    font-size: 22px;
  }
  .content_text {
    font-size: 16px;
  } 
  .support_link {
    font-size: 16px;
  } 
}

@media (min-width: 1920px) {
   .title {
    font-size: 22px;
  }
  .content_text {
    font-size: 18px;
  } 
  .support_link {
    font-size: 16px;
  } 
}
</style>